module.exports = __webpack_public_path__ + "7930fec22dce27aa05a447242489ddd6.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/level_3_rustig.mp3
// module id = 194
// module chunks = 0